import React, { useState, useContext } from 'react';
import LanguageContext from "../helper/LanguageContext";
import "./LazyMedia.css";

/**
 * LazyMedia — lightweight placeholder for media messages (image, audio, doc, video).
 * Shows a small clickable chip instead of loading the heavy media content.
 * On click the real content is rendered in place.
 */
const ICONS = { image: 'image', audio: 'graphic_eq', doc: 'description', video: 'play_circle' };

const LABEL_KEYS = {
  image: 'lazy_media_image',
  audio: 'lazy_media_audio',
  doc: 'lazy_media_doc',
  video: 'lazy_media_video',
};

const FALLBACKS = {
  image: 'Image — Click to load',
  audio: 'Voice message — Click to load',
  doc: 'Document — Click to load',
  video: 'Video — Click to load',
};

const LazyMedia = ({ type, children, eager = false }) => {
  const [loaded, setLoaded] = useState(false);
  const { strings } = useContext(LanguageContext);

  if (eager || loaded) return <>{children}</>;

  const label = (strings && strings[LABEL_KEYS[type]]) || FALLBACKS[type] || 'Media — Click to load';

  return (
    <div
      className="lazy-media-placeholder"
      onClick={(e) => { e.stopPropagation(); setLoaded(true); }}
      role="button"
      tabIndex={0}
    >
      <span
        className="material-symbols-outlined lazy-media-icon lazy-media__icon"
      >
        {ICONS[type] || 'attach_file'}
      </span>
      <span className="lazy-media-label">
        {label}
      </span>
    </div>
  );
};

export default LazyMedia;
